import { render, staticRenderFns } from "./HawkeyePrelabQuiz5.vue?vue&type=template&id=3dfd495a&scoped=true&"
import script from "./HawkeyePrelabQuiz5.vue?vue&type=script&lang=js&"
export * from "./HawkeyePrelabQuiz5.vue?vue&type=script&lang=js&"
import style0 from "./HawkeyePrelabQuiz5.vue?vue&type=style&index=0&id=3dfd495a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfd495a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCheckbox,VForm,VRadio,VRadioGroup})
